/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The battery pack type Parent/child.
 */
export var BatteryType;
(function (BatteryType) {
    BatteryType["PARENT"] = "Parent";
    BatteryType["CHILD"] = "Child";
})(BatteryType || (BatteryType = {}));
